{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"rotation": [0.9932466745376587, -0.11602167785167694, 0, 0],
			"scale": [-0.07651010900735855, -0.7886501550674438, -0.6736917495727539],
			"translation": [-0.8370531797409058, 2.4596433639526367, 0]
		},
		{
			"mesh": 1,
			"name": "Cube.001",
			"rotation": [0.9932467937469482, 0.11602156609296799, 0, 0],
			"scale": [-0.07651010900735855, -0.7886501550674438, -0.6736917495727539],
			"translation": [0.8227914571762085, 2.4309797286987305, 0]
		},
		{
			"mesh": 2,
			"name": "Cube.003",
			"rotation": [0, 0, -0.022966518998146057, 0.9997363090515137],
			"scale": [-0.07895159721374512, -0.04801219701766968, -0.07895159721374512],
			"translation": [-0.6507440805435181, 3.233491897583008, 0.5580189824104309]
		},
		{
			"mesh": 3,
			"name": "Cube.004",
			"rotation": [0, 0, -0.022966518998146057, 0.9997363090515137],
			"scale": [-0.07895159721374512, -0.04801219701766968, -0.07895159721374512],
			"translation": [-0.6507440805435181, 3.233491897583008, -0.5580185651779175]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.6757367849349976, 0.842529296875, 0.863662838935852, 1],
				"metallicFactor": 0.5826771259307861,
				"roughnessFactor": 0.18897701799869537
			}
		},
		{
			"doubleSided": true,
			"name": "Material.005",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.8055132031440735, 0.8055132031440735, 0.8055132031440735, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.010",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.012",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 11,
					"material": 1
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 95,
			"max": [1.938742756843567, 1.0176132917404175, 1],
			"min": [-1.0976765155792236, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 95,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 95,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 228,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 98,
			"max": [1, 0.9599920511245728, 1],
			"min": [-2.121184825897217, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 98,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 98,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 228,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 60,
			"max": [1, 1, 1],
			"min": [-17.352807998657227, -1.5645831823349, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 60,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 60,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 108,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 60,
			"max": [1, 1, 1],
			"min": [-17.352807998657227, -1.5645831823349, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 60,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 60,
			"type": "VEC2"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 1140,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1140,
			"byteOffset": 1140,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 760,
			"byteOffset": 2280,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 456,
			"byteOffset": 3040,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1176,
			"byteOffset": 3496,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1176,
			"byteOffset": 4672,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 784,
			"byteOffset": 5848,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 456,
			"byteOffset": 6632,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 7088,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 7808,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 8528,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 216,
			"byteOffset": 9008,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 9224,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 720,
			"byteOffset": 9944,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 480,
			"byteOffset": 10664,
			"target": 34962
		}
	],
	"buffers": [
		{
			"byteLength": 11144,
			"uri": "armor.bin"
		}
	]
}
